export default {
  page: {
    limit: 10
  },
  comment: {
    limit: 4
  },
  url: 'http://127.0.0.1:8080',
  GA_ID: ''
}
